<template>
    <v-layout style="height: 100%;overflow: hidden;padding: 0px;margin: 0px;">
        <v-container
                style="padding: 0px;margin: 0px;width: 300px;flex-shrink: 0;overflow: auto;max-height: 720px;">
            <v-simple-form title="">
                <template v-slot:toolbar>
                    <v-btn text tile small color="rgba(0,0,0,.7)" @click="goBack">
                        <v-icon color="gray">mdi-step-backward</v-icon>
                        返回
                    </v-btn>
                    <v-btn text tile small color="rgba(0,0,0,.7)" @click="onSave">
                        <v-icon color="gray">mdi-content-save</v-icon>
                        保存
                    </v-btn>
                    <v-spacer/>
                </template>
                <template v-slot:content>
                    <v-form-field :field-width="250" vertical :label-width="70"
                                  v-model="dataItem.name"
                                  label="模板名称"></v-form-field>
                    <v-form-selector v-model="doc.ext.type" :label-width="70" items="公文,纪要,请示件"
                                     :field-width="250"
                                     vertical label="模板类型"></v-form-selector>
                    <!--                    <v-form-field v-if="doc.ext.type=='纪要'||doc.ext.type=='请示件'" label="部门名称" v-model="doc.ext.dept" :field-width="250"-->
                    <!--                                  vertical-->
                    <!--                                  :label-width="70"></v-form-field>-->
                    <!--                    <v-form-field v-if="doc.ext.type=='纪要'||doc.ext.type=='请示件'" label="日期" v-model="doc.ext.date" :field-width="250"-->
                    <!--                                  vertical-->
                    <!--                                  :label-width="70"></v-form-field>-->
                    <v-layout class="flex flex-row">
                        <v-form-switch v-model="doc.docCode.enable" vertical label="发文字号"></v-form-switch>
                        <v-form-switch v-if="doc.docCode.enable" v-model="doc.docCode.bottom" vertical
                                       label="发文字号移到底部"></v-form-switch>
                    </v-layout>
                    <v-form-field v-if="doc.docCode.enable" label="发文机关代字" v-model="docNoOrg" :field-width="250"
                                  vertical
                                  :label-width="70">
                    </v-form-field>
                    <v-form-field v-if="doc.docCode.enable" label="发文顺序号" v-model="docNo" :field-width="250"
                                  vertical
                                  :label-width="70">
                    </v-form-field>
                    <v-form-textarea :height="60" :field-width="250" vertical :label-width="70"
                                     v-model="doc.draftOrg.text"
                                     label="发文机关标志"></v-form-textarea>
                    <v-layout class="flex flex-row">
                        <v-form-switch class="flex-shrink-0 flex-grow-0" true-value="justify" :label-width="70"
                                       false-value="" v-model="doc.draftOrg.align" vertical
                                       label="两端对齐"></v-form-switch>
                        <v-form-selector v-model="doc.draftOrg.scale" :label-width="70"
                                         items="40|0.4,55|0.55,50|0.5,60|0.6,66|0.66,70|0.7,80|0.8,90|0.9,无|1"
                                         :field-width="90"
                                         vertical label="缩放"></v-form-selector>
                        <v-form-switch v-model="doc.draftOrg.bold" vertical
                                       label="加粗"></v-form-switch>
                    </v-layout>
                    <v-form-switch v-model="doc.draftOrg.top" vertical
                                   label="发文机关置顶"></v-form-switch>
                    <v-form-selector v-model="doc.draftOrg.fontSize" :label-width="70"
                                     items="初号|42pt,小初|36pt,一号|26pt,小一|24pt,二号|22pt,小二|18pt,三号|16pt,小三|15pt,四号|14pt,小四|12pt,五号|10.5pt,小五|9pt,六号|7.5pt,小六|6.5pt,七号字|5.5pt,八号字|5pt,48|48pt,46|46pt,54|54pt"
                                     :field-width="250"
                                     vertical label="字体大小"></v-form-selector>
                    <v-form-field label="字间距（磅）" v-model="doc.draftOrg.letterSpace" :field-width="250"
                                  vertical :label-width="70">
                    </v-form-field>
                    <v-form-field label="行高（磅）" v-model="doc.draftOrg.lineHeight" :field-width="250"
                                  vertical :label-width="70">
                    </v-form-field>
                    <v-divider class="mb-2 mt-2"/>
                    <v-layout class="flex flex-row">
                        <v-form-switch v-model="doc.draftPeople.enable" vertical label="签发人"></v-form-switch>
                    </v-layout>
                    <v-divider class="mb-2"/>
                    <v-form-selector v-model="doc.divider" :label-width="70" items="红色双线,红色单线,五角星,无"
                                     :field-width="250"
                                     vertical label="分隔线"></v-form-selector>
                    <v-layout class="flex flex-row">
                        <v-form-switch v-model="doc.toOrg.enable" vertical label="主送机关"></v-form-switch>
                        <v-form-switch v-model="doc.toOrg.bottom" vertical label="移到版记"></v-form-switch>
                    </v-layout>
                    <v-form-switch v-model="doc.title.enable" vertical label="标题"></v-form-switch>
                    <!--                    <v-form-switch v-model="doc.attachment.sequence" vertical label="附件序号"></v-form-switch>-->
                    <v-form-textarea :height="60" :field-width="250" vertical :label-width="70"
                                     v-model="doc.sign.org"
                                     label="发文机关署名"></v-form-textarea>
                    <v-form-selector vertical :field-width="250" number-value item-text="name" item-value="id"
                                     v-model="dataItem.sealId"
                                     data-api="SEAL_LOV"
                                     @change="selectSeal"
                                     label="公章"></v-form-selector>
                    <v-form-switch v-model="doc.ccOrg.enable" vertical label="抄送机关"></v-form-switch>
                    <v-form-field :field-width="250" vertical :label-width="70"
                                  v-model="doc.printOrg.text"
                                  label="印发机关"></v-form-field>
                    <v-layout class="flex flex-row">
                        <v-form-switch v-model="doc.page.enable" vertical label="显示页码"></v-form-switch>
                        <v-form-switch v-model="doc.page.hideFirstPage" vertical
                                       label="首页页码不显示"></v-form-switch>
                    </v-layout>
                </template>
            </v-simple-form>
        </v-container>
        <v-container class="ma-0 pa-0" style="padding: 0px;margin: 0px;">
            <v-container class="ma-0 pa-0">
                <v-toolbar dense style="margin:1px auto;" v-if="false">
                    <v-overflow-btn class="form-input__border mr-1" flat solo v-model="currentElement.font" hide-details
                                    dense
                                    style="max-width: 250px;"
                                    :items="fontFamily"></v-overflow-btn>
                    <v-overflow-btn class="form-input__border" flat solo v-model="currentElement.fontSize" hide-details
                                    dense
                                    style="max-width: 200px;"
                                    :items="fontSize"></v-overflow-btn>
                    <v-spacer/>
                    <v-btn-toggle dense group>
                        <v-btn value="1" @click="alignJustify" v-if="currentElement.type=='发文机关'">
                            <v-icon>mdi-format-overline</v-icon>
                            分散对齐
                        </v-btn>
                        <v-btn value="2" @click="textScale" v-if="currentElement.type=='发文机关'">
                            <v-icon>mdi-format-horizontal-align-center</v-icon>
                            缩放
                        </v-btn>
                    </v-btn-toggle>
                </v-toolbar>
            </v-container>
            <document-viewer v-model="doc"></document-viewer>
        </v-container>
    </v-layout>
</template>

<script>

    import FontFamily from "./fields/FontFamily";
    import FontSize from "./fields/FontSize";
    import DocumentViewer from "../doc/DocumentViewer";

    export default {
        name: "ProjectDetail.vue",
        components: {DocumentViewer},
        data() {
            return {
                docNo: "1",
                docNoOrg: null,
                doc: {
                    ext: {
                        type: 'normal',
                        dept: null,
                        date: null
                    },
                    draftOrg: {
                        type: "发文机关",
                        text: 'XX文件',
                        font: '方正小标宋简体',
                        fontSize: '48pt',
                        letterSpace: 0,
                        align: null,
                        scale: null,
                        enable: true,
                        bold: false
                    },
                    //签发人
                    draftPeople: {
                        type: "签发人",
                        text: '张三',
                        font: '华文楷体',
                        fontSize: '16pt',
                        align: null,
                        scale: null,
                        enable: false
                    },
                    docCode: {
                        type: "发文字号",
                        text: '京械XXX〔2021〕XX号',
                        font: '仿宋_GB2312',
                        fontSize: '16pt',
                        bottom: false,
                        enable: true
                    },
                    title: {
                        type: "标题",
                        text: 'XXXXXXXX',
                        font: '方正小标宋简体',
                        fontSize: '22pt',
                        enable: true
                    },
                    toOrg: {
                        type: "主送机关",
                        text: '各部门',
                        font: '仿宋_GB2312',
                        fontSize: '16pt',
                        bottom: false,
                        enable: true
                    },
                    ccOrg: {
                        type: "抄送机关",
                        text: 'XXXXXXXXXXX',
                        font: '仿宋_GB2312',
                        fontSize: '16pt',
                        enable: false
                    },
                    urgentLevel: null,
                    secretLevel: null,
                    divider: "红色双线",
                    content: {
                        type: "正文",
                        text: "",
                        font: '仿宋_GB2312',
                        fontSize: '16pt',
                        enable: true
                    },
                    attachment: {
                        type: "附件",
                        text: '',
                        sequence: true,
                        font: '仿宋_GB2312',
                        fontSize: '16pt'
                    },
                    printOrg: {
                        type: "印发机关",
                        text: "北京医疗器械检验研究院",
                        date: '2021年10月23日',
                        font: '仿宋_GB2312',
                        fontSize: '14pt',
                        enable: true
                    },
                    sign: {
                        type: "印发日期",
                        org: 'XXX',
                        date: '2014年10月15日',
                        font: '仿宋_GB2312',
                        fontSize: '14pt',
                        enable: true
                    },
                    page: {
                        enable: true,
                        hideFirstPage: true
                    },
                    seal: {
                        type: "公章",
                        imageId: null,
                        uuid: null,
                        url: null,
                        height: 0,
                        width: 0
                    }
                },
                currentElement: {
                    type: null,
                    name: null,
                    font: null,
                    fontSize: null,
                    enable: null
                },
                docId: null,
                dataItem: {
                    id: null,
                    name: null,
                    style: null,
                    sealId: null,
                    draftOrgSign: null,
                    draftOrgTitle: null,
                    docNo: null,
                    docNoOrg: null,
                    printOrg: null
                },
                fontFamily: FontFamily,
                fontSize: FontSize
            }
        },
        created() {
            window.theApp.$emit("APP_DRAWER_TOGGLED");
            this.docId = this.$route.query.id;
            if (this.docId) {
                this.queryDetail(this.docId);
            }
            this.generateDocNoText();
        },
        watch: {
            docNo(val) {
                this.dataItem.docNo = val;
                this.generateDocNoText();
            },
            docNoOrg(val) {
                this.dataItem.docNoOrg = val;
                this.generateDocNoText();
            }

        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            onSave() {
                this.dataItem.style = JSON.stringify(this.doc);
                this.dataItem.draftOrgTitle = this.doc.draftOrg.text;
                this.dataItem.printOrg = this.doc.printOrg.text;
                this.dataItem.docNo = this.docNo;
                this.dataItem.docNoOrg = this.docNoOrg;
                this.$request
                    .request("TEMPLATE_APPLY", this.dataItem)
                    .then((response) => {
                        this.$message.success("保存成功");
                        if (!this.docId) {
                            this.docId = response.data;
                            this.dataItem.id = response.data;
                        }
                    });
            },
            queryDetail(id) {
                this.$request
                    .request("TEMPLATE_DETAIL", {rowid: id})
                    .then(response => {
                        this.dataItem = Object.assign(this.dataItem, response.data)
                        this.doc = Object.assign(this.doc, JSON.parse(this.dataItem.style));
                        this.docNo = this.dataItem.docNo;
                        this.docNoOrg = this.dataItem.docNoOrg;
                    });
            },
            selectElement(eleName, event) {
                this.currentElement = this.doc[eleName];
                let ele = document.querySelector("[active]");
                if (ele) {
                    ele.removeAttribute('active');
                    let originClass = ele.getAttribute("class") || '';
                    if (originClass.indexOf("gw-element") == -1) {
                        originClass = originClass + "gw-element";
                        ele.setAttribute('class', originClass);
                    }
                }
                let id = event.target.id;
                let parent = event.target.parentNode;
                while (!id && parent) {
                    id = parent.id;
                    parent = parent.parentNode;
                }
                if (!id) {
                    this.$message.error("找不到父节点");
                    return;
                }
                document.getElementById(id).setAttribute('active', '');
                let originClass = document.getElementById(id).getAttribute("class") || '';
                if (originClass.indexOf("gw-element") != -1) {
                    originClass = originClass.replace("gw-element", "");
                    document.getElementById(id).setAttribute('class', originClass);
                }
            },
            alignJustify() {
                if (this.currentElement) {
                    if (this.currentElement.align == 'justify') {
                        this.currentElement.align = '';
                    } else {
                        this.currentElement.align = 'justify';
                    }
                }
            },
            textScale() {
                if (this.currentElement) {
                    if (this.currentElement.scale == 'scalex(0.66)') {
                        this.currentElement.scale = '';
                    } else {
                        this.currentElement.scale = 'scalex(0.66)';
                    }
                }
            },
            onPreview() {
                let html = document.getElementById("doc-container").innerHTML;
            },

            /**
             * 将文本转换为标准公文html格式
             * @param c
             * @returns {string}
             */
            convert(content) {
                return this.$tool.text2Html(content);
            },
            /**
             * 选择公章
             * @param item
             */
            selectSeal(item) {
                this.doc.seal = {
                    height: item.height,
                    width: item.width,
                    type: "公章",
                    sealImageId: item.imageId,
                    url: "/fnd/file/download?docId=" + item.imageId
                }
            },
            generateDocNoText() {
                this.doc.docCode.text = this.dataItem.docNoOrg + "〔" + (new Date()).getFullYear() + "〕" + this.docNo + "号";
            }
        }
    }
</script>
